import { Form, Input } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import { useTranslation } from 'react-i18next';
import { handleCreateMyPassword } from '../../fetchHooks/handleCreateMyPassword';
import { ModalTitle } from '../MyDayPage/EditMyday';
import { ModalButtons } from '../MyDayPage/ModalButtons';
import styles from './myPasswords.module.css';

interface CreatePasswordModalProps {
  show: boolean;
  onCancel: () => void;
  onOk: () => void;
}

export const CreatePasswordModal = ({ show, onCancel, onOk }: CreatePasswordModalProps) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  if (!show) return <></>;

  return (
    <Modal
      open={show}
      styles={{ body: { minHeight: '50vh', padding: 0, borderRadius: '20px' } }}
      className={styles.createPasswordModal}
      onCancel={onCancel}
      footer={null}
      onOk={() => console.log('Validate Failed:')}
      forceRender
    >
      <ModalTitle title={t('passwords.createCredential')} />
      <Form
        form={form}
        name="create-password"
        className={styles.createPasswordForm}
        initialValues={{ website: '', password: '' }}
        scrollToFirstError
      >
        <Form.Item
          name="website"
          label={<p>{t('passwords.websiteService')}</p>}
          rules={[
            {
              required: true,
              message: t('passwords.pleaseInputWebsite'),
            },
          ]}
        >
          <Input autoComplete="off" list="autocompleteOff" />
        </Form.Item>
        <Form.Item
          name="username"
          label={t('passwords.username')}
          rules={[
            {
              required: true,
              message: t('passwords.pleaseInputUsername'),
            },
          ]}
        >
          <Input autoComplete="off" list="autocompleteOff" />
        </Form.Item>

        <Form.Item
          name="password"
          label={t('passwords.password')}
          rules={[
            {
              required: true,
              message: t('passwords.pleaseInputPassword'),
            },
          ]}
          hasFeedback
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>

        <Form.Item
          name="confirm"
          label={t('passwords.confirmPassword')}
          dependencies={['password']}
          hasFeedback
          rules={[
            {
              required: true,
              message: t('passwords.pleaseConfirmPassword'),
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t('passwords.passwordsDoNotMatch')));
              },
            }),
          ]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>

        <Form.Item name="comment" label={t('passwords.comment')}>
          <Input.TextArea showCount maxLength={1000} />
        </Form.Item>
        <ModalButtons
          onOk={() => {
            form
              .validateFields()
              .then((values) => {
                const vals = {
                  ...values,
                };
                handleCreateMyPassword(vals, () => {
                  onOk?.();
                });
                form.resetFields();
              })
              .catch((info) => {
                console.log('Create credential: Validate Failed:', info);
              });
          }}
          onCancel={onCancel}
          okText={t('common.add')}
        />
      </Form>
    </Modal>
  );
};
